module.exports = "/_next/static/images/DashboardUnderstand@2x-b6c1ba64df0351a650a60d828eb1efdf.png";